import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentPageHeader, ExtraHeaderPage } from '../../molecules/page-header/ContentPageHeader';
import { PLAYER_COACH } from '../../../constants/define/translation';

interface TourTrashPageHeaderProps {}

export const PlayerProfileHeader = (props: TourTrashPageHeaderProps) => {
  const { t } = useTranslation(PLAYER_COACH);

  const extra: ExtraHeaderPage[] = [];

  return <ContentPageHeader title={t('header.titlePlayer')} extra={extra} />;
};
